export default __webpack_public_path__ + "static/media/il-serpente-crop.4e47c627.jpg";